__turbopack_context__.v({
  "chevron": "MediaModal-module__3_7R8G__chevron",
  "close": "MediaModal-module__3_7R8G__close",
  "fadeIn": "MediaModal-module__3_7R8G__fadeIn",
  "left": "MediaModal-module__3_7R8G__left",
  "media": "MediaModal-module__3_7R8G__media",
  "modal": "MediaModal-module__3_7R8G__modal",
  "overlay": "MediaModal-module__3_7R8G__overlay",
  "right": "MediaModal-module__3_7R8G__right",
  "title": "MediaModal-module__3_7R8G__title",
});
